import { defineMessage } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import getCardOfferTypeAsString from './getCardOfferTypeAsString';


/**
 * Return a string that gives a brief description of the gift card offer for this card.
 *
 * @param {Object} args
 * @param {GiftOfferShape} args.giftCardOffer - The gift card offer details
 * @param {number} args.giftCardOffer.maxDollarValue - The maximum dollar value of the gift card
 * @param {import('react-intl').IntlShape} args.intl - The internationalization object
 * @returns {string} The string that describes the gift card offer
 */
function getGiftOfferSummary({ giftCardOffer, intl }) {
    return intl.formatMessage(
        defineMessage({
            id: 'edb.cc.gift-card-offer',
            defaultMessage: 'Get a <strong>{maxDollarValue, number, CAD0} {offerType}</strong> upon approval',
        }),
        {
            ...DefaultIntlFormatValues,
            maxDollarValue: giftCardOffer.maxDollarValue,
            offerType: getCardOfferTypeAsString(giftCardOffer, intl),
        },
    );
}


export default getGiftOfferSummary;
